import React from 'react'
import { Form, Select, Button, Row, Col, message } from 'antd'
import { useState, useEffect } from 'react'
import apiRequest from './hooks/apiRequest'
import { toast } from 'react-toastify'
const { Option } = Select

function ViewClaimModel(props) {
  const [accessorId, setaccessorId] = useState()
  const [assessorsList, setAssessorsList] = useState()
  const [assessorName, setAssessorName] = useState()
  const [processorList, setProcessorList] = useState()
  const [claimCreationData, setClaimCreationData] = useState();
  const [documentList, setDocumentList] = useState([]);
  const productId=localStorage.getItem("productId");
  console.log('dd', props)
  // useEffect(() => {
  //   // fetch('http://64.227.72.205:8001/auth/accessors')
  //   //   .then(res => res.json())
  //   //   .then(data => {
  //   //     setAssessorsList(data)
  //   //   })
  //   const fetchData=async()=>{
  //     const response=await apiRequest(`https://outoversite.kindlebit.com/api/Auth/GetAllClaimUsersByInsurerId?insurerid=248`,'GET');
  //     console.log(response)
  //     setAssessorsList(response?.data)
  //   }
  //   fetchData();
  // }, [props]);

 const fetchDocument = async (id) => {
  const InsurerID=props?.parentToChild?.insurerId;
    const DocumentData = await apiRequest(
      process.env.REACT_APP_BASE_URL_DOCUMENT + `/ModuleDocument/ByModule/${InsurerID}/${productId}`,
      'GET',
    )
    console.log('DocumentData',DocumentData)
    setDocumentList(DocumentData?.data)
  }

  const fetchClaimData = async (claimId) => {
    try {
      const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Claim/GetClaimById/${claimId}`, 'GET')

      if (response.success) {
        setClaimCreationData(response.data.result.claim_creation);
      }
      console.log('fetched data', response.data.result.claim_creation);
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const updateClaimValidation = async () => {
    try {
      const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Claim/UpdateClaim/update`, 'POST', claimCreationData)
      if (response.success) {
        console.log("Validation updated successfully!");
        props.closeModale();
      }
    } catch (error) {
      console.error('Error fetching module documents:', error)
    }
  }


  useEffect(() => {
    const fetchData = async () => {
      try {
        fetchClaimData(props.parentToChild.id);

        // debugger
        const storedRoleId = JSON.parse(localStorage.getItem('user'));
        console.log('storedRoleId', storedRoleId)
        const roleID = parseInt(storedRoleId?.role) + 1;
        localStorage.setItem("roleID", roleID);
        if (!storedRoleId) {
          console.error('Role ID not found in localStorage');
          return;
        }
        // const roleId = parseInt(storedRoleId); // convert to number
        const response = await apiRequest(
          `https://outoversite.kindlebit.com/api/Auth/GetAllClaimUsersByInsurerId?insurerid=248`,
          'GET'
        );

        if (storedRoleId?.role == 305) {
          // Filter users with matching roleId
          const filteredUsers = response?.data?.filter(user => user.roleId == 312);
          setAssessorsList(filteredUsers || []);
        } else {
          const filteredUsers = response?.data?.filter(user => user.roleId == roleID);
          setAssessorsList(filteredUsers || []);
        }

        console.log('==>', assessorsList);
      } catch (error) {
        console.error('Error fetching or filtering users:', error);
      }
    };
    fetchData();
    fetchDocument();
  }, []);

  function handleChangeAccessor(value, option) {
    setaccessorId(parseInt(value))
    setAssessorName(option.props.fullName)
  }

  function handleSubmit() {
    if (!accessorId) {
      toast.error(`Please select ${localStorage.getItem('ModalTitle')}`);
    } else {
      // toast.success(`${ localStorage.getItem('ModalTitle') } assigned sucessfully`);
      // props.closeModale()
      var dataP = props.parentToChild
      dataP.accessor_id = parseInt(accessorId)
      dataP.accessor_name = assessorName
      dataP.claim_notes = ''
      // fetch(
      //   process.env.REACT_APP_BASE_URL + '/claim/GetClaimQuotation/' + dataP.id,
      // )
      //   .then(res => res.json())
      //   .then(data => {
      //     if (data.length !== 0) {
      //       dataP.claim_status = 'Assessment'
      //       dataP.user_id = localStorage.getItem('loggedInUserID')
      //       dataP.user_name = localStorage.getItem('username')
      //       postData(dataP)
      //     } else postData(dataP)
      //   })
      postData(dataP)
    }
  }

  async function postData(val) {
    // const requestMetadata = {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify(val),
    // }
    // debugger
    // fetch(
    //   process.env.REACT_APP_BASE_URL + '/claim/CreateClaim',
    //   requestMetadata,
    // )
    //   .then(res => res.json())
    //   .then(data => {
    //     if (data.responseStatus === true) {
    //       message.success('Assessor assigned successfully !!')
    //     }
    //     window.location.href = '/claims'
    //   })

    const req_body = {
      claimId: props.parentToChild.id,
      accesorId: accessorId,
      accesorName: assessorName,
      claimStatus: props.parentToChild.claim_status,
    }

    // console.log(req_body)

    const response = await apiRequest(process.env.REACT_APP_BASE_URL + '/Claim/UpdateAccessor/update-accessor', 'POST', req_body)

    console.log('update assessor', response);
    if (response.success) {

      if (localStorage.getItem('roles') === '"CLAIMS_INITITATOR"') {
        claimCreationData.claim_status = "Assessment";
        updateClaimValidation()
      }

      // if (localStorage.getItem('roles') === '"CLAIMS_PROCESSOR"') {
      //   claimCreationData.claim_status = "Awaiting Authorisation";
      //   updateClaimValidation()
      // }

      toast.success(`Assessor assigned sucessfully`);
      props.closeModale();
    }
  }

  return (
    <div>
      <Row gutter={[16, 24]} style={{ display: 'inline' }}>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Customer Name : </b> {props.parentToChild.customer_name}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Claim No. : </b> {props.parentToChild.claim_number}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Policy No. : </b>
            {props.parentToChild.policy_number}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b> Date of Loss : </b>
            {props.parentToChild.date_of_loss}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b> Date of Notification :</b>{' '}
            {props.parentToChild.date_of_notification}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Claim Amount : </b>
            {props.parentToChild.claim_amount}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Claim Status : </b>
            {props.parentToChild.claim_status}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Assigned To : </b>
            {props.parentToChild.accessor_name}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b>Claim Item :</b> {props.parentToChild.itemdetails}
          </label>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <label>
            <b> Approved Amount :</b> {props.parentToChild.approved_amount}
          </label>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <label>
            <b> Damage Description :</b>{' '}
            {props.parentToChild.damage_description}
          </label>
        </Col>
      </Row>
      {localStorage.getItem('userType') === 'CLAIMS_PROCESSOR' ||
        'CLAIMS_MANAGER' ? (
        <div>
          <div>
            <Select
              // placeholder="--Assign Assessor--"
              placeholder={`--Assign ${localStorage.getItem('ModalTitle')}--`}
              name="mode_of_notification"
              onChange={handleChangeAccessor}>
              {assessorsList &&
                assessorsList.map(x => (
                  <Option key={x.userId} value={x.userId} fullName={`${x.firstName} ${x.lastName}`}>
                    {`${x?.firstName} ${x?.lastName}`}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="add-button" style={{ marginTop: '25px' }}>
            <Button
              onClick={handleSubmit}
              size="default"
              className="primary m-t-0 w-50">
              Assign
            </Button>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}
const WrappedViewClaimModel = Form.create({ name: 'Homeinsurance_list' })(
  ViewClaimModel,
)

export default WrappedViewClaimModel
